import { render, staticRenderFns } from "./AssessmentScoreCard.vue?vue&type=template&id=3907b8fa&scoped=true"
import script from "./AssessmentScoreCard.vue?vue&type=script&lang=ts"
export * from "./AssessmentScoreCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907b8fa",
  null
  
)

export default component.exports